import constants from '@/config/constants';

const nav = constants.nav;

//Vue Watcher
import { watch } from 'vue';

//Vue Router
import { createRouter, createWebHistory } from 'vue-router';

//Auth0 Route Guard
import { authGuard, useAuth0 } from '@auth0/auth0-vue';

const guard = (to, from, next) => {
  //First, ensure the user is authenticated using Auth0's authGuard
  authGuard(to);

  //Get the roles required for the route from the route meta
  const requiredRoles = to.meta.rbac;

  //Use Auth0 to get ID token claims (which contains user info and roles)
  const { idTokenClaims } = useAuth0();

  //Function to check if the user has the required roles
  const checkAccess = (claims) => {

    const roles = claims[constants.auth.namespaces.roles] || []; //Get the users roles
    const hasAccess = requiredRoles && requiredRoles.some(role => roles.includes(role)); //Check if the required roles includes at least 1 user role

    if (hasAccess) {

      next(); //User has required role, proceed to the route

    } else {

      next({ name: nav.unauthorized.name }); //Redirect to dashboard if user lacks required role
    }
  };

  if (!idTokenClaims.value) {

    //If ID token claims are not loaded yet, set up a watcher
    const unwatch = watch(() => idTokenClaims.value, (claims) => {

      if (claims) {

        unwatch(); //Stop watching after user data is loaded

        checkAccess(claims); //Check user roles
      }

    }, { immediate: true });

  } else {

    //If ID token claims are already available, perform role check directly
    checkAccess(idTokenClaims.value);
  }
};

const routes = [
  {
    path: '/unauthorized',
    name: 'unauthorized',
    meta: nav.unauthorized.meta,
    component: () => import(/* webpackChunkName: 'unauthorized' */ '../views/UnauthorizedView'),
    beforeEnter: guard,
  },
  {
    path: '/',
    name: 'default',
    meta: nav.default.meta,
    component: () => import(/* webpackChunkName: 'default' */ '../views/DefaultView'),
    beforeEnter: guard,
  },
  {
    path: '/pair',
    name: 'pairing',
    meta: nav.pairing.meta,
    component: () => import(/* webpackChunkName: 'pairing' */ '../views/PairingView'),
    beforeEnter: guard,
  },
  {
    path: '/screen',
    name: 'screen',
    meta: nav.screen.meta,
    component: () => import(/* webpackChunkName: 'display' */ '../views/DisplayView'),
    beforeEnter: guard,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

//Set the title for each page
router.afterEach((to) => {
  document.title = `${to.meta.title ?? constants.app.meta.subName}\u00A0|\u00A0${constants.app.meta.name}`;
});

export default router
